module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-a96a3ea0.png";